export default [
    "DIA", "NOITE", "AMBOS"
];